module.exports = __webpack_public_path__ + "static/media/QuestionMarkIcon.06a5c482.svg";